import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class UpdateTicketProduct extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>
                <h3 className="mb0 mt40"> 상품 수정</h3>

                <div className="blog-post-meta">
                    <span className="s-post">등록한 상품의 정보를 수정/업데이트 할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">PUT</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/tickets/{'{travelProductId}'}</td>
                            <td>https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/tickets/1234567890
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="8" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_8} className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>sellerProductId</td>
                            <td>X</td>
                            <td>String</td>
                            <td>셀러에서 상품을 관리하기 위해 사용한 유닉 아이디</td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <td colSpan={level1}>travelType</td>*/}
                        {/*    <td>O</td>*/}
                        {/*    <td>String</td>*/}
                        {/*    <td>*/}
                        {/*        <table className="table table-striped">*/}
                        {/*            <tbody>*/}
                        {/*            <tr>*/}
                        {/*                <td>생성 후 변경불가 항목 입니다</td>*/}
                        {/*                <td></td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th>Optional Value</th>*/}
                        {/*                <th>Description</th>*/}
                        {/*                <th></th>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <td>DOMESTIC</td>*/}
                        {/*                <td>국내여행</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <td>OVERSEAS</td>*/}
                        {/*                <td>해외여행</td>*/}
                        {/*            </tr>*/}
                        {/*            </tbody>*/}
                        {/*        </table>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td colSpan={level1}>inventoryType</td>*/}
                        {/*    <td>O</td>*/}
                        {/*    <td>String</td>*/}
                        {/*    <td>*/}
                        {/*        <table className="table table-striped">*/}
                        {/*            <tbody>*/}
                        {/*            <tr>*/}
                        {/*                <td>Inventory Type</td>*/}
                        {/*                <td></td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <th>Optional Value</th>*/}
                        {/*                <th>Description</th>*/}
                        {/*                <th></th>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <td>DAILY</td>*/}
                        {/*                <td>매일</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <td>PERIOD</td>*/}
                        {/*                <td>기간</td>*/}
                        {/*            </tr>*/}
                        {/*            </tbody>*/}
                        {/*        </table>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        <tr>
                            <td colSpan={level1}>name</td>
                            <td>O</td>
                            <td>String</td>
                            <td>여행상품명</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>adultOnly</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>19세미만 구매불가. Default:FALSE</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>reservationRequired</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>사전 예약예약 여부,인벤토리 타입이 Daily 일 경우 이 필드의 값은 false 입니다. Default:FALSE</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>subordinateIds</td>
                            <td>X</td>
                            <td>Array</td>
                            <td>상품관리 서브ID 리스트</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>searchTags</td>
                            <td>O</td>
                            <td>Array</td>
                            <td>서치태그 리스트</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>images</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrl</td>
                            <td>O</td>
                            <td>String</td>
                            <td>셀러 이미지 URL</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrlMethod</td>
                            <td>X</td>
                            <td>String</td>
                            <td>Http method(GET/POST), default GET</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>representative</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>이미지가 상품 대표함, 상품당 단일 대표이미지 보유. Default: FALSE</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerImageCategory</td>
                            <td>X</td>
                            <td>String</td>
                            <td>셀러 이미지 카테고리</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>imageGroup</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>VIEW</td>
                                        <td>내외관/전경</td>
                                    </tr>
                                    <tr>
                                        <td>FACILITY</td>
                                        <td>부대시설</td>
                                    </tr>
                                    <tr>
                                        <td>RESTAURANT</td>
                                        <td>식당</td>
                                    </tr>
                                    <tr>
                                        <td>ETC</td>
                                        <td>기타</td>
                                    </tr>
                                    <tr>
                                        <td>ROOM</td>
                                        <td>객실</td>
                                    </tr>
                                    <tr>
                                        <td>BASIC</td>
                                        <td>기본</td>
                                    </tr>
                                    </tbody>
                                </table>
                                디폴트 값: BASIC
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>description</td>
                            <td>X</td>
                            <td>String</td>
                            <td>이미지 설명</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>seq</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>이미지 순서.</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>trafficInfo</td>
                            <td>X</td>
                            <td>String</td>
                            <td>찾아가는 길 설명하는 자유텍스트 입력.</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>publicTransportInfo</td>
                            <td>X</td>
                            <td>String</td>
                            <td>주변 대중교통 정보 설명하는 자유 텍스트 입력.</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>nearbyLandmarks</td>
                            <td>X</td>
                            <td>Array</td>
                            <td>주변 관광지 정보</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>name</td>
                            <td>O</td>
                            <td>String</td>
                            <td>랜드마크명</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>latitude</td>
                            <td>X</td>
                            <td>Double</td>
                            <td>랜드마크 위도 정보</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>longitude</td>
                            <td>X</td>
                            <td>Double</td>
                            <td>랜드마크 경도 정보</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>distance</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>랜드마크까지의 거리</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>distanceUnit</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                Default:METER
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>KILOMETER</td>
                                        <td>킬로미터</td>
                                    </tr>
                                    <tr>
                                        <td>METER</td>
                                        <td>미터</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>direction</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>EAST</td>
                                        <td>동</td>
                                    </tr>
                                    <tr>
                                        <td>WEST</td>
                                        <td>서</td>
                                    </tr>
                                    <tr>
                                        <td>NORTH</td>
                                        <td>북</td>
                                    </tr>
                                    <tr>
                                        <td>SOUTH</td>
                                        <td>남</td>
                                    </tr>
                                    <tr>
                                        <td>NORTHEAST</td>
                                        <td>북동</td>
                                    </tr>
                                    <tr>
                                        <td>NORTHWEST</td>
                                        <td>북서</td>
                                    </tr>
                                    <tr>
                                        <td>SOUTHEAST</td>
                                        <td>남동</td>
                                    </tr>
                                    <tr>
                                        <td>SOUTHWEST</td>
                                        <td>남서</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>transportations</td>
                            <td>X</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>type</td>
                            <td>X</td>
                            <td>String</td>
                            <td>

                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>SUBWAY</td>
                                        <td>지하철</td>
                                    </tr>
                                    <tr>
                                        <td>BUS</td>
                                        <td>버스</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>description</td>
                            <td>X</td>
                            <td>String</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>operationPeriods</td>
                            <td>X</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>startTime</td>
                            <td>X</td>
                            <td>String</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level4}>endTime</td>
                            <td>X</td>
                            <td>String</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>locations</td>
                            <td>O</td>
                            <td>Array</td>
                            <td>*travelType이 OVERSEAS인 경우 locations가 필수 값이 아님. Locations 값이 입력된 경우 꼭 정확한 값으로 입력해야함.</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>latitude</td>
                            <td>X</td>
                            <td>Double</td>
                            <td>목적지 위도 정보</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>longitude</td>
                            <td>X</td>
                            <td>Double</td>
                            <td>목적지 경도 정보</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>roadNameAddress</td>
                            <td>X</td>
                            <td>String</td>
                            <td>도로명주소.도로명 또는 지번주소 중 최소한 한가지는 입력해야 함</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>landNumberAddress</td>
                            <td>X</td>
                            <td>String</td>
                            <td>지번주소. 도로명 또는 지번주소 중 최소한 한가지는 입력해야 함</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>nation</td>
                            <td>O</td>
                            <td>String</td>
                            <td>국가</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>province</td>
                            <td>X</td>
                            <td>String</td>
                            <td>행정단위 주</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>city</td>
                            <td>O</td>
                            <td>String</td>
                            <td>도시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>district</td>
                            <td>O</td>
                            <td>String</td>
                            <td>구, 구역</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>town</td>
                            <td>X</td>
                            <td>String</td>
                            <td>읍 면 동</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>zipCode</td>
                            <td>X</td>
                            <td>String</td>
                            <td>우편번호</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>contents</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>title</td>
                            <td>X</td>
                            <td>String</td>
                            <td>여행상품 컨텐츠 타이틀</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>type</td>
                            <td>X</td>
                            <td>String</td>
                            <td>컨텐츠 타입에 대한 자유텍스트 입력. 예:패키지 투어</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>content</td>
                            <td>X</td>
                            <td>String</td>
                            <td>'이미지' 포맷이 아닌 경우 선택, '이미지'이면 필수</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>format</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>IMAGE</td>
                                        <td>IMAGE</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrl</td>
                            <td>X</td>
                            <td>String</td>
                            <td>'이미지'포맷인 경우 sellerUrl 이 image url 이며 필수임, 그 외 선택
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrlMethod</td>
                            <td>X</td>
                            <td>String</td>
                            <td>Http method(GET/POST), default GET.</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>seq</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>컨텐츠 순서</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>features</td>
                            <td>X</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>featureId</td>
                            <td>X</td>
                            <td>String</td>
                            <td>자세한 내용을 엑셀 파일을 참고해 주십시오.
                                {/*<table className="table table-striped">
                                                <tbody>
                                                <tr>
                                                    <th>FeatureId</th>
                                                    <th>Required Or Not</th>
                                                    <th>Description</th>
                                                </tr>
                                                <tr>
                                                    <td>ADDITIONAL_EXPENSE</td>
                                                    <th>Required</th>
                                                    <td>추가경비 포함</td>
                                                </tr>
                                                <tr>
                                                    <td>FREE_SCHEDULE</td>
                                                    <th>Required</th>
                                                    <td>자유일정 포함</td>
                                                </tr>
                                                <tr>
                                                    <td>SHOPPING</td>
                                                    <th>Required</th>
                                                    <td>쇼핑포함 여부</td>
                                                </tr>
                                                </tbody>
                                            </table>*/}
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>featureValues</td>
                            <td>X</td>
                            <td>Array</td>
                            <td>자세한 내용을 엑셀 파일을 참고해 주십시오.
                                {/*<table className="table table-striped">
                                                <tbody>
                                                <tr>
                                                    <th>FeatureId</th>
                                                    <th>Feature Optional Value</th>
                                                </tr>
                                                <tr>
                                                    <td>ADDITIONAL_EXPENSE</td>
                                                    <td>ADDITIONAL_EXPENSE_INCLUDE,ADDITIONAL_EXPENSE_EXCLUDE</td>
                                                </tr>
                                                <tr>
                                                    <td>FREE_SCHEDULE</td>
                                                    <td>ADDITIONAL_EXPENSE_EXCLUDE,FREE_SCHEDULE_INCLUDE</td>
                                                </tr>
                                                <tr>
                                                    <td>SHOPPING</td>
                                                    <td>SHOPPING_INCLUDE,SHOPPING_EXCLUDE</td>
                                                </tr>
                                                </tbody>
                                            </table>*/}
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>description</td>
                            <td>X</td>
                            <td>String</td>
                            <td>속성 설명</td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <td colSpan={level1}>themes</td>*/}
                        {/*    <td>X</td>*/}
                        {/*    <td>Array</td>*/}
                        {/*    <td>자세한 내용을 엑셀 파일을 참고해 주십시오.*/}
                        {/*        /!* <table className="table table-striped">*/}
                        {/*                        <tbody>*/}
                        {/*                        <tr>*/}
                        {/*                            <th>Optional Value</th>*/}
                        {/*                            <th>Description</th>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>REST</td>*/}
                        {/*                            <td>휴양</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>SIGHT_SEEING</td>*/}
                        {/*                            <td>관광</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>WATER_SPORTS</td>*/}
                        {/*                            <td>해양스포츠</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>CRUISE</td>*/}
                        {/*                            <td>크루즈</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>SPA_TRAVEL</td>*/}
                        {/*                            <td>온천여행</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>ACCOMMODATION_THEME_63</td>*/}
                        {/*                            <td>가족여행</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>FORMAL_TRAVEL</td>*/}
                        {/*                            <td>효도여행</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>TRAVEL_ALONE</td>*/}
                        {/*                            <td>나홀로 여행 </td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>WITH_FRIENDS</td>*/}
                        {/*                            <td>친구랑</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>GROUP</td>*/}
                        {/*                            <td>단체/모임</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>HONEYMOON</td>*/}
                        {/*                            <td>허니문</td>*/}
                        {/*                        </tr>*/}
                        {/*                        <tr>*/}
                        {/*                            <td>PREMIUM</td>*/}
                        {/*                            <td>프리미엄</td>*/}
                        {/*                        </tr>*/}
                        {/*                        </tbody>*/}
                        {/*                    </table>*!/*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        <tr>
                            <td colSpan={level1}>reservationGuide</td>
                            <td>X</td>
                            <td>Object</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>title</td>
                            <td>X</td>
                            <td>String</td>
                            <td>예약가이드 타이틀</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>type</td>
                            <td>X</td>
                            <td>String</td>
                            <td>컨텐츠 타입 자유텍스트 입력</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>content</td>
                            <td>X</td>
                            <td>String</td>
                            <td>‘이미지’포맷이 아닌 경우 선택, 이미지이면 필수</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>format</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>TEXT</td>
                                        <td>TEXT</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrl</td>
                            <td>X</td>
                            <td>String</td>
                            <td>‘이미지’포맷인 경우 sellerUrl 이 image url이며 필수임, 그 외 선택</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrlMethod</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                Http method(GET/POST), default GET.
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>seq</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>컨텐츠 순서</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>reservationNotifications</td>
                            <td>X</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>type</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>PHONE</td>
                                        <td>전화</td>
                                    </tr>
                                    <tr>
                                        <td>FAX</td>
                                        <td>팩스</td>
                                    </tr>
                                    <tr>
                                        <td>EMAIL</td>
                                        <td>이메일</td>
                                    </tr>
                                    {/* <tr>
                                                    <td>WEBSITE</td>
                                                    <td>웹사이트</td>
                                                </tr>*/}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>contactInfo</td>
                            <td>O</td>
                            <td>String</td>
                            <td>이메일 주소, 전화번호 혹은 팩스 번호</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>contactDescription</td>
                            <td>X</td>
                            <td>String</td>
                            <td>연락처 설명</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>contacts</td>
                            <td>O</td>
                            <td>Array</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>contactType</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>PHONE</td>
                                        <td>전화</td>
                                    </tr>
                                    <tr>
                                        <td>FAX</td>
                                        <td>팩스</td>
                                    </tr>
                                    <tr>
                                        <td>EMAIL</td>
                                        <td>이메일</td>
                                    </tr>
                                    <tr>
                                        <td>WEBSITE</td>
                                        <td>웹사이트</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>contactUseType</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>REPRESENTATIVE</td>
                                        <td>대표연락처*필수</td>
                                    </tr>
                                    <tr>
                                        <td>BOOKING_INQUIRY</td>
                                        <td>예약문의 연락처</td>
                                    </tr>
                                    <tr>
                                        <td>CANCEL_INQUIRY</td>
                                        <td>취소문의 연락처</td>
                                    </tr>
                                    <tr>
                                        <td>EMERGENCY</td>
                                        <td>긴급연락망</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>contact</td>
                            <td>O</td>
                            <td>String</td>
                            <td>예: 연락처 타입이 폰이면: 010-0000-0000</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>cancelPolicy</td>
                            <td>O</td>
                            <td>Object</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>notice</td>
                            <td>X</td>
                            <td>String</td>
                            <td>취소공지</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>cancelType</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>AUTO</td>
                                        <td>자동취소</td>
                                    </tr>
                                    <tr>
                                        <td>APPROVAL</td>
                                        <td>승인취소</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <td>&nbsp;</td>*/}
                        {/*    <td colSpan={level2}>cancelPeriodType</td>*/}
                        {/*    <td>O</td>*/}
                        {/*    <td>String</td>*/}
                        {/*    <td>*/}
                        {/*        <table className="table table-striped">*/}
                        {/*            <tbody>*/}
                        {/*            <tr>*/}
                        {/*                <th>Optional Value</th>*/}
                        {/*                <th>Description</th>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <td>BEFORE_USE</td>*/}
                        {/*                <td>사용 처리전 가능(유효기간 종료시까지)</td>*/}
                        {/*            </tr>*/}
                        {/*            <tr>*/}
                        {/*                <td>AFTER_7DAYS</td>*/}
                        {/*                <td>구매일 + 7일 이내 가능</td>*/}
                        {/*            </tr>*/}
                        {/*            </tbody>*/}
                        {/*        </table>*/}
                        {/*    </td>*/}
                        {/*</tr>*/}
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>cancelMarkType</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>NONE</td>
                                        <td>해당 없음</td>
                                    </tr>
                                    <tr>
                                        <td>NOT_CANCELED</td>
                                        <td>취소불가</td>
                                    </tr>
                                    <tr>
                                        <td>UNUSE_REFUND_ALL</td>
                                        <td>미사용 100%환불</td>
                                    </tr>
                                    <tr>
                                        <td>NOT_REFUND_AFTER_RECEIPT</td>
                                        <td>티켓 발송 후 환불 불가</td>
                                    </tr>
                                    <tr>
                                        <td>NOT_REFUND_AFTER_RESERVATION_CONFIRM</td>
                                        <td>예약 확정 후 환불 불가</td>
                                    </tr>
                                    <tr>
                                        <td>UNUSE_REFUND_ALL_BEFORE_ONE_DAY</td>
                                        <td>이용일 1일전까지 100%환불</td>
                                    </tr>
                                    <tr>
                                        <td>DEPENDING_ON_VENDOR</td>
                                        <td>업체 규정에 따름</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>refundOnBusinessDay</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>영업일 기준 취소 접수 여부 (Default: false)</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>refundUnusedTicket</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>미사용 티켓 100% 환불 여부 (Default: false)</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>refundRates</td>
                            <td>X</td>
                            <td>Array</td>
                            <td>만약 cancelMarkType이 ‘업체규정에 따름’인 경우, 환불율 필수</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>conditionDays</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>사용일 x 일 전 까지 환불 가능</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>conditionTime</td>
                            <td>O</td>
                            <td>String</td>
                            <td>사용일 x 일 y 시 전 까지 환불 가능 format: HH:mm:ss
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>refundRate</td>
                            <td>O</td>
                            <td>Double</td>
                            <td>환불율 ex: rate 70% is 70</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>cancellable</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>아이템 판매 상태 (Default: TRUE)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>introduction</td>
                            <td>O</td>
                            <td>String</td>
                            <td>여행 상품 소개말</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>notice</td>
                            <td>X</td>
                            <td>String</td>
                            <td>이용안내 및 유의사항</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>benefits</td>
                            <td>X</td>
                            <td>Array</td>
                            <td>특별히 제공되는 혜택 및 보너스‘란 구매 고객에게 특별하게 제공되는
                                혜택으로 실제 본 상품외에 무료 혹은 할인되어 제공되는 선물이나 서비스를 말합니다.
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>insuranceInfo</td>
                            <td>X</td>
                            <td>Object</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>title</td>
                            <td>X</td>
                            <td>String</td>
                            <td>보험정보 타이틀</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>type</td>
                            <td>X</td>
                            <td>String</td>
                            <td>컨텐츠 타입 자유텍스트 입력</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>content</td>
                            <td>X</td>
                            <td>String</td>
                            <td>‘이미지’포맷이 아닌 경우 선택, 이미지이면 필수</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>format</td>
                            <td>O</td>
                            <td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>TEXT</td>
                                        <td>TEXT</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrl</td>
                            <td>X</td>
                            <td>String</td>
                            <td>‘이미지’포맷인 경우 sellerUrl 이 image url이며 필수임, 그 외 선택l</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>sellerUrlMethod</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                Http method(GET/POST), default GET.
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>seq</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>컨텐츠 순서</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>inclusionNotice</td>
                            <td>X</td>
                            <td>String</td>
                            <td>포함사항 기재 (최대 문자열 길이는 2000자 입니다)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>exclusionNotice</td>
                            <td>X</td>
                            <td>String</td>
                            <td>불포함 사항 기재 (최대 문자열 길이는 2000자 입니다)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>publication</td>
                            <td>X</td>
                            <td>Object</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>useBarcode</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>쿠팡 티켓번호 바코드 변환 여부 ((Default: false)</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>isUseDirect</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>즉시사용 여부, 숙박의 경우 : true, 기타 타입의 경우 : false</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>externalCouponUseType</td>
                            <td>X</td>
                            <td>String</td>
                            <td>외부티켓번호 사용유형</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>useExternalTicketNumber</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>외부티켓번호 사용여부</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketUsage</td>
                            <td>O</td>
                            <td>Object</td>
                            <td>
                                티켓제공밥법
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td>PURCHASE</td>
                                        <td>구매</td>
                                    </tr>
                                    <tr>
                                        <td>BARCODE</td>
                                        <td>바코드</td>
                                    </tr>
                                    <tr>
                                        <td>BARCODE_REAL_TIME</td>
                                        <td>바코드 실시간</td>
                                    </tr>
                                    <tr>
                                        <td>E_TICKET</td>
                                        <td>E-티켓</td>
                                    </tr>
                                    <tr>
                                        <td>DELIVERY</td>
                                        <td>배송</td>
                                    </tr>
                                    <tr>
                                        <td>ON_SITE</td>
                                        <td>현장</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketSendCriteriaType</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                티켓 발송 기준
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>DAY</td>
                                        <td>일</td>
                                    </tr>
                                    <tr>
                                        <td>TIME</td>
                                        <td>시간</td>
                                    </tr>
                                    <tr>
                                        <td>NONE</td>
                                        <td>없음</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketSendSpentTime</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>티켓 발송 소요 시간</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketSendLimitTime</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>티켓 당일 발송 기준 시간</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>usageNotice</td>
                            <td>X</td>
                            <td>String</td>
                            <td>유의사항 기재 (최대 문자열 길이는 2000자 입니다)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>additionalInfoPrompt</td>
                            <td>X</td>
                            <td>String</td>
                            <td>상품 주문/예약에 필요한 고객정보를 수집할수 있습니다</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>maxPurchaseQuantity</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>일인당 구매 최대 개수</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>csContactInfo</td>
                            <td>O</td>
                            <td>String</td>
                            <td>예약안내 (최대 문자열 길이는 2000자 입니다)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>taxType</td>
                            <td>X</td>
                            <td>String</td>
                            <td>
                                *travelType이 OVERSEAS인 경우 taxType이 자동으로 면세(FREE)로 설정되며, 이외의 taxType를 설정 할 수 없습니다.
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Optional Value</th>
                                        <th>Description</th>
                                    </tr>
                                    <tr>
                                        <td>TAX</td>
                                        <td>과세 (기본값)</td>
                                    </tr>
                                    <tr>
                                        <td>FREE</td>
                                        <td>면세</td>
                                    </tr>
                                    <tr>
                                        <td>ZERO</td>
                                        <td>영세</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>instantBooking</td>
                            <td>X</td>
                            <td>Boolean</td>
                            <td>구매즉시 예약 (Default: false)</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>estimatedBookingDuration</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>예약확정 소요시간, 즉시예약이 FALSE 라면 필요.데이터는 0 부터 72까지이며</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>extension</td>
                            <td>X</td>
                            <td>{"Map<String,String>"}</td>
                            <td>기타 정보사항 자유 텍스트 입력</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#updateTourDto">Request Body</a>
                        </div>
                        <div id = "updateTourDto" className = "panel-collapse collapse">
                            <div id = "createTourDto" className="panel-body">
                    <pre className="ty01">
                        {`
{
  "additionalInfoPrompt": "string",
  "adultOnly": true,
  "benefits": [
    "string"
  ],
  "cancelPolicy": {
    "cancelMarkType": "NOT_REFUND_AFTER_RECEIPT",
    "cancelType": "AUTO",
    "notice": "string",
    "refundOnBusinessDay": true,
    "refundUnusedTicket": true
  },
  "contacts": [
    {
      "contact": "010-0000-0000",
      "contactType": "PHONE",
      "contactUseType": "REPRESENTATIVE"
    }
  ],
  "contents": [
    {
                "title": "product content title 2",
                "type": "Product-Content",
                "content": null,
                "format": "IMAGE",
                "sellerUrl": "http://img.modetour.com/eagle/photoimg/39982/bfile/635116574873322964.jpg",
                "sellerUrlMethod": "GET",
                "seq": 0
            }
  ],
  
  "csContactInfo": "string",
 
  "displayKeyword": "string",
  "estimatedBookingDuration": 0,
  "exclusionNotice": "string",
  "extension": {},
  "features": [
  \t{
  \t\t"description":"",
  \t\t"featureId":"TYPE",
  \t\t"featureValues":[
  \t\t\t"WIFI","CAMERA"
  \t\t\t]
  \t}
  ],
  "images": [
            {
                "sellerUrl": "http://img.modetour.com/eagle/photoimg/39975/bfile/635993410305760918.JPG",
                "sellerUrlMethod": "GET",
                "representative": true,
                "sellerImageCategory": "1234",
                "imageGroup": "BASIC",
                "description": "image 1 description",
                 "seq": 0
            }
  ],
  "inclusionNotice": "string",
  "instantBooking": true,
  "introduction": "string",
  "inventoryType": "DAILY",
  "maxPurchaseQuantity": 0,
  "name": "Test Update Product 999999",
  "notice": "string",
  "publicTransportInfo": "string",
  "publication": {
    "externalCouponUseType": "string",
    "isUseDirect": true,
    "ticketSendCriteriaType": "string",
    "ticketSendLimitTime": 0,
    "ticketSendSpentTime": 0,
    "ticketUsage": "string",
    "useBarcode": true,
    "useExternalTicketNumber": true
  },
  "searchTags": [
    "string"
  ],
  "sellerProductId": "string",
  "subordinateIds": [
    "string"
  ],
  "taxType": "ZERO",
  "themes": [
    "string"
  ],
  "trafficInfo": "string",
  "travelItems": [
    {
      "description": "string",
        "features": [
        \t{
        \t\t"description":"",
        \t\t"featureId":"OFFERING_SERVICE",
        \t\t"featureValues":[
        \t\t\t"NO_CHARGE_CALL","UNLIMITED_USE"
        \t\t\t]
        \t}
      ],
      "name": "test item 2",
      "onSale": true,
      "rates": [
        {
          "maxPurchaseQtyPerPerson": 0,
          "maxPurchaseQtyPeriod": 0,
          "price": 0,
          "priceType": "COUPANG_PRICE",
          "rateType": "BASIC",
          "representative": true,
          "saleEndedAt": "2019-12-31 23:59:59",
          "saleStartedAt": "2019-10-01 00:00:00",
          "sellerRateId": "",
          "seq": 0
        }
      ],
      "sellerTravelItemId": "string",
      "seq": 0,
      "taxType": "TAX",
      "usePeriod": {
        "useEndedAt": "2019-12-31 23:59:59",
        "usePeriodName": "string",
        "useStartedAt": "2019-12-01 23:59:59"
      }
    }
  ],
 
  "usageNotice": "test"
}
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td>data</td>
                            <td>Long</td>
                            <td>여행상품 id</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
  "code": 0,
  "data": 0,
  "message": "string"
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다
                                <div>
                                    <a data-toggle="collapse" href="#errorMessagesForUpdateProduct">400 Error Messages</a>
                                </div>
                                <div id="errorMessagesForUpdateProduct" className="panel-collapse collapse">
                                    <div className="panel-body">
                                        <li>이넘 타입 {'${enumClazz.getSimpleName()}'}에 대한 무효 문자열 값</li>
                                        <li>images가 비어있을 수 없음</li>
                                        <li>대표 이미지 단 한장만 허용 가능</li>
                                        <li>국내 여행에 대한 locations가 비어있으면 안됨 </li>
                                        <li>landNumberAddress중 하나와 roadNameAddress를 제공해야함</li>
                                        <li>무효 seqs </li>
                                        <li>format이 IMAGE가 아닌 경우 content를 반드시 제공해야함</li>
                                        <li>format이 IMAGE인 경우 sellerUrl를 반드시 제공해야함</li>
                                        <li>instantBooking이 false인 경우 estimatedBookingDuration이 0보다 크고 72보다 작거나 같아야됨</li>
                                        <li>연락처에 대표 전화 번호가 하나 있어야함 </li>
                                        <li>무효 travel feature id </li>
                                        <li>무효 travel feature value</li>
                                        <li>무효 일자/시간 포맷, 포맷이 {'{pattern}'}이어야함</li>
                                        <li>판매 시작일은 판매 종료일보다 늦지 않아야함</li>
                                        <li>상품 inventoryType이 PERIOD인 경우 usePeriod가 NULL이면 안됨</li>
                                        <li>inventoryType이 DAILY인 경우 usePeriod가 불필요함</li>
                                        <li>publication은 null이 아니어야함</li>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketProductAPI/UpdateTicketProduct.jsx